import { Grid, Typography } from "@mui/material";
import { GridSortModel } from "@mui/x-data-grid";
import { Profile, TestScore } from "@readyfit-common/models";
import { OrganizationRecruitmentProcess } from "src/store/reducers/organizations/organizationsApiSlice";
import useStyles from "../AthleteDetails.styles";
import PastTestsDataGrid from "../PastTestsDataGrid/PastTestsDataGrid";
import RecruitmentProcessCard from "../RecruitmentProcessCard/RecruitmentProcessCard";
import TestProgressChart from "../TestProgressChart/TestProgressChart";

interface TestingTabProps {
  athlete: Profile;
  organizationRecruitmentProcess: OrganizationRecruitmentProcess;
  scores: TestScore[];
  areScoreLoading: boolean;
  sortModel: GridSortModel;
  setSortModel: (sortModel: GridSortModel) => void;
  getAthleteScores: () => void;
  sortBy: string;
  setSortBy: (sortBy: string) => void;
  handleExportPastTests: () => void;
}
export const TestingTab = ({
  athlete,
  organizationRecruitmentProcess,
  scores,
  areScoreLoading,
  sortModel,
  setSortModel,
  getAthleteScores,
  sortBy,
  setSortBy,
  handleExportPastTests,
}: TestingTabProps) => {
  const classes = useStyles();
  return (
    <Grid container>
      <RecruitmentProcessCard
        athlete={athlete}
        organizationRecruitmentProcess={organizationRecruitmentProcess}
      />
      {/* Tests progress */}
      <Grid container marginTop={3} className={classes.testsProgressContainer}>
        <TestProgressChart scores={scores} />
      </Grid>

      {/* PAST TESTS */}
      <Grid container marginTop={3}>
        <PastTestsDataGrid
          testScores={scores}
          isLoading={areScoreLoading}
          sortModel={sortModel}
          setSortModel={setSortModel}
          getAthleteScores={getAthleteScores}
          sortBy={sortBy}
          setSortBy={setSortBy}
          exportPastTests={handleExportPastTests}
        />
      </Grid>
    </Grid>
  );
};

export default TestingTab;
